import Styled, { css } from 'styled-components'
import { DownOutlined } from '@ant-design/icons'

export const LabelContainer = Styled.div<{ disabled: boolean; bordered: boolean; width?: string }>`
  width: ${({ width }) => (width ? width : '100%')};
  max-width: 400px;
  height: auto;
  display: flex;
  justify-content: ${({ bordered }) => (bordered ? 'space-between' : 'flex-start')};
  align-items: flex-start;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  position: relative;
  border: ${({ bordered }) => bordered && '1px solid #D1D4D9'};
  border-radius: ${({ bordered }) => bordered && '0.6rem'};
  padding: ${({ bordered }) => bordered && '0.8rem 1.6rem'};
  font-size: ${({ bordered }) => (bordered ? '1.4rem' : '2rem')};
`
export const Label = Styled.label`
  width: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  & > p {
    max-width: 300px;
    max-height: 58px;
    font-weight: 600;
    margin: 0 8px 0 0;
    white-space: normal;
    color: rgba(0,0,0,0.85);
  }
`
export const Controls = Styled.div`
  width: auto;
  display: flex;
  justify-content: flex-start;
`
export const DropDown = Styled.section<{ show: boolean; withoutSearch: boolean; width }>`
  display: ${({ show }) => (show ? 'block' : 'none')};
  width: ${({ width }) => width};
  height: auto;
  max-height: 338px;
  border: 0.5px solid #cccccc;
  border-radius: 8px;
  padding: ${({ withoutSearch }) => (withoutSearch ? '0.4rem' : '1.6rem')};
  background-color: white;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.75);
  position: absolute;
  z-index:10;
`
export const Down = Styled(DownOutlined)`
  margin: 7px 0 0 0;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`
export const Icon = Styled.span`
  width: 2rem;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  margin: 0 8px 0 0;
  color: rgba(0, 0, 0, 0.85);
`
export const Tag = Styled.span`
  width: 65px;
  height: 20px;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  border-radius: 4px;
  margin: 5px 15px 0 0;
  text-align: center;
  background-color: #f3f5f9;
  border: 0.5px solid #d1d4d9;
`
export const Search = Styled.div`
  display: flex;
  justify-content: flex-start;

  & > input{
    width: calc(100% - 32px);
    height: 32px;
    border: 1px solid rgba(0, 0, 0, 0.25);
    border-right: 0;
    padding: 0 0 0 10px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    outline: none;

    &::placeholder{
      color: rgba(0, 0, 0, 0.25);
      font-size: 14px;
    }
  }
  & > span{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    border: 1px solid rgba(0, 0, 0, 0.25);
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }
`
export const ItemList = Styled.ul<{ withoutSearch?: boolean }>`
  width: 100%;
  height: auto;
  max-height: 264px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin: ${({ withoutSearch }) => (withoutSearch ? '0' : '10px 0 0 0')};
  padding: 0;
  overflow-y: auto;
  list-style-type: none;

  ${() =>
    css`
      &::-webkit-scrollbar {
        width: 8px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: rgba(193, 193, 193, 1);
        border-radius: 5px;
      }
      &::-webkit-scrollbar-track {
        background-color: transparent;
      }
    `}
`
export const Item = Styled.li`
  width: 100%;
  height:auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-height: 32px;
  font-size: 14px;
  padding: 5px 12px;
  overflow: hidden;
  color: rgb(0, 0, 0);
  cursor: pointer;
  &:hover{
    background-color: #E6F7FF;
  }
`
export const infiniteScroll: React.CSSProperties = {
  width: '100%'
}
